import { observer } from 'mobx-react-lite'
import { Dispatch, SetStateAction, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useStore } from 'store/useStore'
import { PersonalUserDataDTO } from 'sections/LKSection/shared/types/types'
import { Flex, Modal, Skeleton, Text } from 'components/uiKit'
import { getSharedKey } from 'utils/helpers/i18n/getKeys'

import { EmployeeKeys } from '../../../data'
import { Employee } from '../../../stores/entity/Employee'

type DeleteEmployeeModalProps = {
  employee: Employee
  personalData: PersonalUserDataDTO | null
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

const getKey = (key: string) => `${EmployeeKeys.employeePage}.${key}`

export const DeleteEmployeeModal = observer(({ employee, open, personalData, setOpen }: DeleteEmployeeModalProps) => {
  const { viewEmployeeUiStore: uiStore } = useStore()

  const [loading, setLoading] = useState(false)
  const { t } = useTranslation()

  const deleteButtonHandler = async () => {
    if (employee.id) {
      setLoading(true)
      const res = await uiStore.deleteUser(employee.id)
      setLoading(false)

      if (res) {
        setOpen(false)
      }
    }
  }

  return (
    <Modal
      title={t(getKey('Удаление сотрудника'))}
      open={open}
      onOk={deleteButtonHandler}
      okText={t(getSharedKey('delete'))}
      onCancel={() => setOpen(false)}
      okButtonProps={{ disabled: !personalData, danger: true, loading }}
    >
      <Skeleton loading={!personalData}>
        <Flex vertical>
          <Text>{t(getKey('Вы уверены, что хотите удалить'))}</Text>
          <Text strong>{`${personalData?.firstName} ${personalData?.lastName}`}</Text>
        </Flex>
      </Skeleton>
    </Modal>
  )
})
